export default __webpack_public_path__ + "assets/img/ict-trash.9fed2a3fe6882d570da3604cce4fe6c2.svg";